jQuery(document).ready(function ($) {
  setMenuPageItems();
  hideFakeMenuIfAddedLocation();
});
function hideFakeMenuIfAddedLocation() {
  var $ = jQuery.noConflict();

  // Get values from localStorage
  const storeLocationName = localStorage.getItem('ecw_customer_store_location_name');
  const deliveryMode = localStorage.getItem('ecw_customer_deliverymode');
  const storeLocationURL = localStorage.getItem('ecw_visitor_order_url');

  if (storeLocationName && deliveryMode) {
    // console.log('Both items are set.');

    // Hide all general menu items and show all specific menu items
    $('ul>li.general-menu').each(function() {
      $(this).addClass('hide');
    });
    $('ul>li.specific-menu').each(function() {
      $(this).removeClass('hide');
      $(this).find('a').attr({
        'href': '/order/#menu',
        'data-close': '' // Adds the data-close attribute
    });
    }); 

  } else if (storeLocationURL) {
    // console.log('storeLocationURL', storeLocationURL);
    // Hide all general menu items and show all specific menu items
    $('ul>li.general-menu').each(function() {
      $(this).addClass('hide');
    });
    $('ul>li.specific-menu').each(function() { 
      $(this).removeClass('hide');
      $(this).find('a').attr('href', storeLocationURL); 
    });
    // $('ul>li.general-menu').each(function() {
    //   $(this).addClass('hide');
    // });
    // $('ul>li.specific-menu').each(function() {
    //   $(this).removeClass('hide');
    //   $(this).find('a').attr('href', '/order/'); 
    // }); 
  } else {
    // console.log('Both items are not set.', visitorOrderUrl);

    // Show all general menu items and hide all specific menu items
    $('ul>li.general-menu').each(function() {
      $(this).removeClass('hide');
    });
    $('ul>li.specific-menu').each(function() {
      $(this).addClass('hide');
      $(this).find('a').attr({
        'href': '/order/#menu',
        'data-close': '' // Adds the data-close attribute
    });
    });
  }
}

function setMenuPageItems() {
  var $ = jQuery;
  if ($('.wf-menu-list').length) {
    var locIndex = -1;
    var locMenu = [];

    // if(localStorage.getItem('ecw_visitor_nearest_location_id') && localStorage.getItem('ecw_visitor_nearest_location_id') !== 'null') {
    //   for(var i = 0; i < loc.length; i++) {
    //     if(loc[i][3] ==localStorage.getItem('ecw_visitor_nearest_location_id')) {
    //       locIndex = i;
    //       break;
    //     }
    //   }
    //   var locMenu = $.parseJSON(loc[locIndex][9]);
    // }

    if (localStorage.getItem('ecw_visitor_nearest_location_id') && localStorage.getItem('ecw_visitor_nearest_location_id') !== 'null') {

      $('[data-loading-spinner-container]').removeClass('hide');

      $.ajax({
        type: 'POST',
        url: ajax_url, 
        data: {
          action: 'get_olo_menu',
          location_id: localStorage.getItem('ecw_visitor_nearest_location_id'), 
          referer: window.location.href

        },
        success: function (response) {
          // console.log(JSON.parse(response));

          var result = JSON.parse(response);
          var imagePath = result.data.imagepath;
          var productCats = result.data.categories;

          var isFirst = true;

          for (var j = 0; j < productCats.length; j++) {
            var $menuTabClone = $('.wf-menu-list #menu-tabs [data-menu-tab-template]').clone(),
              $menuTabDropdownClone = $('.wf-menu-list #menu-tabs-dropdown [data-menu-tab-template]').clone(),
              $menuContentClone = $('.wf-menu-list [data-menu-tab-content-template]').clone();

            var menuCatName = productCats[j].name;
            var menuCatSlug = string_to_slug(menuCatName) + "_" + j;


            if (isFirst) {
              $menuTabClone.addClass('is-active');
              $menuTabClone.find('a').attr('aria-selected', 'true');

              $menuTabDropdownClone.addClass('is-active');
              $menuTabDropdownClone.find('a').attr('aria-selected', 'true');
            }

            $menuTabClone.find('a').attr('href', '#' + menuCatSlug);
            $menuTabClone.find('a').attr('aria-controls', menuCatSlug);
            $menuTabClone.find('a').attr('id', menuCatSlug + '-label');
            $menuTabClone.find('a').text(menuCatName);

            $menuTabDropdownClone.find('a').attr('href', '#' + menuCatSlug);
            $menuTabDropdownClone.find('a').attr('aria-controls', menuCatSlug);
            $menuTabDropdownClone.find('a').attr('id', menuCatSlug + '-label');
            $menuTabDropdownClone.find('a').text(menuCatName);


            if (isFirst) {
              $menuContentClone.addClass('is-active');
            }

            $menuContentClone.attr('id', menuCatSlug);
            $menuContentClone.attr('aria-labelledby', menuCatSlug + '-label');
            $menuContentClone.prepend('<h2 class="menu-cat-title">' + menuCatName + '</h2>');


            var products = productCats[j].products;

            for (var jj = 0; jj < products.length; jj++) {

              var currProduct = products[jj];
              var $menuProductClone = $menuContentClone.find('[data-menu-product-template]').clone();

              var menuProdSlug = string_to_slug(currProduct.name) + "_" + j + "_modal";

              var imageURL = imagePath + products[jj].imagefilename;

              // Main Element
              $menuProductClone.find('[data-menu-image-modal]').attr('style', 'background-image:url(' + imageURL + ')');
              $menuProductClone.find('[data-menu-image]').attr('src', imageURL);
              $menuProductClone.find('[data-menu-image]').attr('alt', currProduct.name + ' Primary Image');

              $menuProductClone.find('[data-menu-title]').text(currProduct.name);
              $menuProductClone.find('[data-product-description]').text(currProduct.description);

              var descrString = [];
              if (currProduct.cost && currProduct.cost !== '0') {
                descrString.push('$' + parseFloat(currProduct.cost).toFixed(2));
              }
              if (currProduct.calories) {
                descrString.push(currProduct.calories);
              }
              $menuProductClone.find('[data-menu-description]').html(descrString.join(" &bull; "));

              // Modal
              $menuProductClone.find('[data-menu-modal-button]').attr('data-open', menuProdSlug);
              $menuProductClone.find('[data-menu-modal]').attr('id', menuProdSlug);

              if (menuCatName.toLowerCase().includes('sides') || menuCatName.toLowerCase().includes('sauce') || menuCatName.toLowerCase().includes('drink') || menuCatName.toLowerCase().includes('kit') ||
                currProduct.name.toLowerCase().includes('sides') || currProduct.name.toLowerCase().includes('sauce') || currProduct.name.toLowerCase().includes('drink') || currProduct.name.toLowerCase().includes('kit')) {
                $menuProductClone.find('[data-product-build-bowl]').remove();
              }

              if (currProduct.cost && currProduct.cost !== '0') {
                $menuProductClone.find('[data-menu-price]').text('$' + parseFloat(currProduct.cost).toFixed(2) + '**');
              } else {
                $menuProductClone.find('[data-price-disclaimer]').remove();
              }

              if (currProduct.calories) {
                $menuProductClone.find('[data-nutrition-data]').html('<li><strong>Calories:</strong> ' + currProduct.calories + '*</li>')
              } else {
                $menuProductClone.find('[data-nutrition]').remove();
                $menuProductClone.find('[data-nutrition-disclaimer]').remove();
              }

              // $menuProductClone.find('[data-order-link]').attr('href', loc[locIndex][7]);

              // Foundation init on element
              var modalElem = new Foundation.Reveal($menuProductClone.find('[data-menu-modal]'));

              $menuProductClone.removeClass('hide');
              $menuProductClone.removeAttr('data-menu-product-template');

              $menuContentClone.find('> .grid-x').append($menuProductClone);

            }

            $menuTabClone.removeAttr('data-menu-tab-template');
            $menuTabDropdownClone.removeAttr('data-menu-tab-template');
            $menuContentClone.removeAttr('data-menu-tab-content-template');

            $menuTabClone.removeClass('hide');
            $menuTabDropdownClone.removeClass('hide');
            $menuContentClone.removeClass('hide');

            $('.wf-menu-list #menu-tabs[data-menu-tabs]').append($menuTabClone);
            $('.wf-menu-list #menu-tabs-dropdown[data-menu-tabs]').append($menuTabDropdownClone);
            $('.wf-menu-list [data-menu-tab-contents]').append($menuContentClone);

            isFirst = false;

          }

          $('.wf-menu-list #menu-tabs [data-menu-tab-template]').remove();
          $('.wf-menu-list #menu-tabs-dropdown [data-menu-tab-template]').remove();
          $('.wf-menu-list [data-menu-tab-content-template]').remove();

          $('.wf-menu-list .menu-container').removeClass('hide');
          $('.wf-menu-list [data-no-location-set]').addClass('hide');


          $('#menu-tabs-dropdown a').click(function (e) {
            e.preventDefault();
            // console.log('blort', $(this).attr('href'), $('#menu-tabs a[href="' + $(this).attr('href') + '"]'));
            $('#menu-tabs a[href="' + $(this).attr('href') + '"]').click();
            $('#menu-tabs-dropdown').foundation('close');
          });

          $(".menu-tab-all a").click(function () {
            // console.log('add');
            $(".tabs-panel").addClass("all-active");
            $(".menu-tab-all").find('a').attr('aria-selected', 'true');
            $(".menu-tab-all").find('a').attr('tabindex', '0');
          });

          $(".remove-all a").click(function () {
            // console.log('remove');
            $(".tabs-panel").removeClass("all-active");
            $(".menu-tab-all").find('a').attr('aria-selected', 'false');
            $(".menu-tab-all").find('a').attr('tabindex', '-1');
          });

          $('[data-loading-spinner-container]').addClass('hide');

        },
        error: function () {
          $('[data-loading-spinner-container]').addClass('hide');
          $('.wf-menu-list .menu-container').addClass('hide');
          $('.wf-menu-list [data-no-location-set]').removeClass('hide');
        }
      });
    } else {
      $('.wf-menu-list .menu-container').addClass('hide');
      $('.wf-menu-list [data-no-location-set]').removeClass('hide');
    }
  }
}